// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609180804/js/" + chunkId + "." + {"44":"929e18d5","225":"fdfaad15","481":"070b8eca","486":"897cd99d","770":"073d7b8a"}[chunkId] + ".0.41646763259413644.chunk.js";
};